import $ from "jquery";

import Util from "../../services/util";
import Store from "../../services/store";

import SectionHeader from "../../components/section-header/section-header.vue";
import CategoryItem from "../../components/category-item/category-item.vue";
import ProductItem from "../../components/product-item/product-item.vue";
import Breadcrumb from "../../components/breadcrumb/breadcrumb.vue";
import NotFound from "../../components/not-found/not-found.vue";

export default {
  name: "Brand",

  created() {
    $("html, body").animate({ scrollTop: 0 }, 0);

    this.slug = this.$route.params.slug;
    this.breadcrumb = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb));
    if (!this.store._id) return;

    this.fetchBrand();
    this.fetchCategories();
    this.loadMore();
  },

  destroyed() {
    Util.setTitle();
    window.onscroll = null;
  },

  components: {
    SectionHeader,
    CategoryItem,
    ProductItem,
    Breadcrumb,
    NotFound,
  },

  methods: {
    fetchBrand(pop = false) {
      this.loading = true;
      return Store.getBrands(this.store._id)
        .then((x) => {
          const brands = x.data || [];
          this.brand =
            brands.find(
              (b) => b.slug === this.slug || b._id === this.slug
            ) || null;

          if (!this.brand) return this.$router.push({ path: "/404" });

          this.pushBreadcrumb(pop);
          this.fetchProducts();
          this.loading = false;
          document.title = this.brand.name;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },

    fetchProducts(infinite = false, page = this.productsObject.pageNumber) {
      if (!this.brand || !this.brand._id) return;

      this.ploading = true;
      return Store.getProductsByBrand(
        this.store._id,
        this.brand._id,
        page,
        this.productsObject.itemsPerPage
      )
        .then((x) => {
          this.productsObject = x.data;

          if (!infinite) this.products = this.productsObject.items;
          else this.productsObject.items.forEach((i) => this.products.push(i));

          this.ploading = false;
        })
        .catch((e) => {
          console.log(e);
          this.ploading = false;
        });
    },

    loadMore() {
      window.onscroll = () => {
        const bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >=
          document.documentElement.offsetHeight;

        setTimeout(() => {
          if (bottomOfWindow && !this.ploading && !this.loading) {
            if (this.products.length == this.productsObject.totalItems) return;
            const page = this.productsObject.pageNumber + 1;
            this.fetchProducts(true, page);
          }
        });
      };
    },

    fetchCategories() {
      this.cloading = true;
      return Store.getCategories(this.store._id, 12, false)
        .then((x) => {
          this.categories = x.data;
          this.cloading = false;
        })
        .catch((e) => {
          console.log(e);
          this.cloading = false;
        });
    },

    pushBreadcrumb(pop) {
      const item = { text: this.brand.name, disabled: true, href: "" };
      if (pop) this.breadcrumb.pop();
      this.breadcrumb.push(item);
    },
  },

  watch: {
    "$route.params"(n) {
      if (n && n.slug) {
        this.slug = n.slug;
        this.products = [];
        this.productsObject.pageNumber = 1;
        this.fetchBrand(true);
      }
    },
  },

  computed: {
    store() {
      return this.$store.state.storeInfo;
    },

    productGridUI() {
      return this.$store.state.storeInfo.webstore?.productGridUI || 2;
    },

    categoryGridUI() {
      return this.store.webstore?.categoryGridUI || 2;
    },

    isMobile() {
      return this.$store.state.isMobile;
    },
  },

  data() {
    return {
      slug: "",
      breadcrumb: [],

      loading: false,
      ploading: false,
      cloading: false,

      brand: {},
      categories: [],
      products: [],
      productsObject: {
        pageNumber: 1,
        items: [],
        totalItems: 0,
        totalPages: 0,
        itemsPerPage: 24,
      },
    };
  },
};
